import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.createClassSchool.loading;
export const selectErrorMessage = (state: RootState) =>
  state.createClassSchool.error;
export const createdClassListResponse = (state: RootState) =>
  state.createClassSchool.createClassResponse;
export const classCreated = (state: RootState) => state.createClassSchool.saved;
